<template lang="pug">
  .page-container
    Toolbar
    .app-breadcrumbs
      v-container.breadcrumbs-container
        img.breadcrumbs-logo(src="../../assets/logo.png")/
        v-breadcrumbs(:items="breadcrumbs")
          template(slot="item" slot-scope="props")
            router-link(
              :to="props.item.to"
              class="app-breadcrumbs__item"
            ) {{ props.item.text }}
    v-container
      v-layout
        v-flex(xs3)
          v-navigation-drawer(floating permanent )
            v-toolbar(flat)
              v-list
                v-list-tile
                  v-list-tile-title.title {{ $t("userInfo.userInfo") }}
            v-list
              v-list-tile(v-for='item in items' :key="item.title" @click="$router.push({name: item.name})")
                v-list-tile-action
                  v-icon {{ item.icon }}
                v-list-tile-content
                  v-list-tile-title {{ item.title }}
        v-flex(xs9)
          .userinfo
            .item {{ $t("userInfo.nickname") }}
              span {{userInfo.name}}
            .item {{ $t("userInfo.phoneNumber") }}
              span {{userInfo.phone}}

            v-btn.logout(@click='handleLogout') {{ $t("userInfo.logout") }}

</template>

<script>
import { mapState } from "vuex";
import Toolbar from "../../components/common/toolbar";
import { mapMutations } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["userInfo"]),
    items() {
      return [
        {
          title: this.$t("userInfo.userProfile"),
          icon: "account_box",
          name: ""
        },
        {
          title: this.$t("userInfo.addressManagement"),
          icon: "dashboard",
          name: "address"
        },
        {
          title: this.$t("userInfo.changePassword"),
          icon: "gavel",
          name: "update-pwd"
        }
      ];
    },
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("nav.home")
        },
        {
          to: { name: "userinfo" },
          disabled: true,
          text: this.$t("userInfo.userInfo")
        }
      ];
    }
  },
  methods: {
    ...mapMutations(["setToken", "setUserInfo"]),

    handleLogout() {
      this.setToken("");
      this.setUserInfo({});
      this.$router.push({ name: "account" });
    }
  },
  components: {
    Toolbar
  }
};
</script>

<style scoped lang="sass" src="./userinfo.sass"></style>
